import { MaterialIcon } from "@website/icons/material";
import { useRadio } from "@website/ui/radio/radio.hook";
import styles from "@website/ui/radio/radio.module.scss";
import { RadioPropertiesType } from "@website/ui/radio/radio.types";
import { deepCompare } from "@website/utils/deep-compare";
import { FC, memo } from "react";

const Radio: FC<RadioPropertiesType> = (properties) => {
  const { inputProps } = useRadio(properties);
  const { checked, ...properties_ } = inputProps;

  const { className, labelClassName, color, disabled, label, icon } =
    properties;

  return (
    <label
      className={`${styles["radio"]} ${disabled ? styles["disabled"] : ""} ${
        className ?? ""
      }`}
    >
      <input
        checked={checked ?? false}
        {...properties_}
        className={styles["input"]}
      />
      <div className={styles["box"]}>
        <MaterialIcon
          className={styles["un-checked-icon"]}
          name="radio_button_unchecked"
          variant="outlined"
        />
        <MaterialIcon
          className={`${styles["checked-icon"]} ${styles[color || "primary"]}`}
          name="radio_button_checked"
          variant="outlined"
        />
        <div className={`${styles["ripple"]} ${styles[color || "primary"]}`} />
      </div>
      <span className={`${styles["label"]} ${labelClassName}`} hidden={!label}>
        {label}
      </span>
      {icon}
    </label>
  );
};

const RadioMemoized = memo(Radio, deepCompare);
export { RadioMemoized as Radio };
